import axios from 'axios';
export const fileService = {
	getAll,
	getAllStartFilesDetails
};

var qs = require('qs');

function getAll(params) {
	const CancelToken = axios.CancelToken;
	const source = CancelToken.source();
	return axios
		.get('Tracking/FileListFromBucket', {
			params: params,
			cancelToken: source.token,
			paramsSerializer: function(params) {
				return qs.stringify(params, { arrayFormat: 'repeat' });
			}
		})
		.then(handleResponse)
		.catch((error) => {
			return Promise.reject(error);
		});
}

function getAllStartFilesDetails(params) {
	return axios
		.get('Tracking/FileListFromBucket', {
			params: params
		})
		.then(handleResponse)
		.catch((error) => {
			return Promise.reject(error);
		});
}

function handleResponse(response) {
	if (response.data.Errors && response.data.Errors.length > 0) {
		// TODO handle error
		return Promise.reject(response.data.Errors[0]);
	}
	return Promise.resolve(response.data);
}
